import { render, staticRenderFns } from "./shopping-cart-wizard.vue?vue&type=template&id=89acd8c2&"
import script from "./shopping-cart-wizard.vue?vue&type=script&lang=ts&"
export * from "./shopping-cart-wizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports